import { useState } from "react";
import {
  backendShape,
  withBackend,
  Container,
  notifierShape,
  withNotifier,
  isSomething,
} from "lcm-iot-commons";
import RequestPasswordResetForm from "./RequestPasswordResetForm";
import RequestPasswordResetResponse from "./RequestPasswordResetResponse";

type Props = {
  backend: backendShape;
  notifier: notifierShape;
};

export function RequestPasswordReset({ backend, notifier }: Props) {
  const [responseType, setResponseType] = useState();

  const handleOnSubmit = async (values: $TSFixMe, actions: $TSFixMe) => {
    try {
      const resetPasswordRequest = {
        email: values.email,
        captcha: values.captcha,
      };
      const response = await backend.post(
        "/users/request_password_reset",
        resetPasswordRequest,
      );
      setResponseType(response.type);
    } catch (error) {
      notifier.showError(backend.translateError(error));
    } finally {
      actions.setSubmitting(false);
    }
  };

  return (
    <Container>
      {isSomething(responseType) ? (
        <RequestPasswordResetResponse
          // @ts-expect-error TS(2322) FIXME: Type '{ id: string; type: undefined; }' is not ass... Remove this comment to see the full error message
          id="request-password-response"
          type={responseType}
        />
      ) : (
        <RequestPasswordResetForm
          // @ts-expect-error TS(2322) FIXME: Type '{ id: string; onSubmit: (values: any, action... Remove this comment to see the full error message
          id="request-password-form"
          onSubmit={handleOnSubmit}
        />
      )}
    </Container>
  );
}

export default withNotifier(withBackend(RequestPasswordReset));
